function Logo_Component({text}) {
    
    return (
         <div className="container-sm fs-1">
          <p className="txt-gold Font-DancingScript autoType_font_size">
            {text}
            {/* "Celebrating You, the Traditional Way!!" */}
          </p>
        </div>
    )
}
export default Logo_Component;